import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { ADMIN_LOGIN_PATH } from 'config';
import { selectIsAuthenticated } from 'store/selectors';

const AdminAuthGuard = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={ADMIN_LOGIN_PATH} />;
  }

  return children;
};

export default AdminAuthGuard;
